import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useBankAccountService = () => {
    const { doGet, doPost, doDelete } = useFetch();

    const [fetchingGetBankAccountsBySociety, setFetchingGetBankAccountsBySociety] = useState(false);
    const [fetchingDeleteBankAccount, setFetchingDeleteBankAccount] = useState(false);
    const [fetchingCreateSocietyBankAccount, setFetchingCreateSocietyBankAccount] = useState(false);
    const [fetchingStoreSocietyBankAccount, setFetchingStoreSocietyBankAccount] = useState(false);

    const getBankAccountsBySociety = (societyId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BANK_ACCOUNT.BANK_ACCOUNT_BY_SOCIETY.replace(':society_id', societyId.toString()),
            setFetching: setFetchingGetBankAccountsBySociety
        });
    };

    const deleteBankAccount = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.BANK_ACCOUNT.DELETE_BANK_ACCOUNT.replace(':id', id.toString()),
            setFetching: setFetchingDeleteBankAccount
        });
    };

    const createSocietyBankAccount = (societyId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BANK_ACCOUNT.CREATE_SOCIETY_BANK_ACCOUNT.replace(':society_id', societyId.toString()),
            setFetching: setFetchingCreateSocietyBankAccount
        });
    };

    const storeSocietyBankAccount = (bankAccountData: object, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.BANK_ACCOUNT.STORE_SOCIETY_BANK_ACCOUNT,
            body: bankAccountData,
            setFetching: setFetchingStoreSocietyBankAccount
        });
    };

    return {
        getBankAccountsBySociety,
        deleteBankAccount,
        createSocietyBankAccount,
        storeSocietyBankAccount,
        fetchingGetBankAccountsBySociety,
        fetchingDeleteBankAccount,
        fetchingCreateSocietyBankAccount,
        fetchingStoreSocietyBankAccount
    };
};

export default useBankAccountService;
